<template>
  <div style="z-index: 999999 !important; background-color: #ffffff">
    <!--  强制提醒   -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :label="$t('trajectory.trackingUpdateAlert')"
      :show-close="false"
      :visible.sync="trajectoryDialog"
      top="10vh"
      width="600px"
    >
      <div style="display: flex; align-items: center">
        <div><i class="el-icon-warning" style="font-size: 25px; color: red" /></div>
        <div style="margin-left: 8px; margin-bottom: 10px">
          <div style="font-size: 16px; font-weight: bold">
            {{ $t('trajectory.customerTrackingAlert') }}
          </div>
          <div>{{ $t('trajectory.penaltyWarning') }}</div>
        </div>
      </div>
      <el-table
        ref="tableRef"
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        height="420"
        style="width: 100%"
      >
        <el-table-column
          :label="$t('trajectory.customer')"
          align="center"
          min-width="180"
          prop="customerName"
        />
        <el-table-column
          :label="$t('collectionCenter.NumberPackages')"
          align="center"
          min-width="100"
          prop="orderCount"
        />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="toHandleFun(1)">{{
          $t('trajectory.acknowledgeClose')
        }}</el-button>
        <el-button
          size="small" type="primary" @click="toHandleFun(2)"
        >{{ $t('trajectory.handleImmediately') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { stationaryAlertTrackAlert } from '@/api/newExpressAPI';

export default {
  data() {
    return {
      trajectoryDialog: false,
      tableData: []
    };
  },
  methods: {
    toHandleFun(val) {
      if (val === 1) {
        this.trajectoryDialog = false;
      } else {
        this.trajectoryDialog = false;
        this.$router.push({ path: '/TrajectoryManagementCenter/trajectoryUpdateManagement' });
      }
    },
    async showTrajectory() {
      const res = await stationaryAlertTrackAlert();
      console.log(res, 'showTrajectory');
      if (res.code === 200) {
        this.tableData = res.data;
      }
      if (this.tableData.length > 0) {
        this.trajectoryDialog = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dispatchName {
  width: 100%;
  height: 39px;
  border: 1px solid #dbdee5;
  padding-left: 10px;
  text-align: left;
  border-radius: 4px;
}
</style>
